export default {
  type: 'No label',
  description: '',
  filename: '',
  isOpen: true
}
